<template>
<div class="box-labourParticulars">
    <div class="nav">
        <img src="../../assets/up.png" alt="" class="upClass" @click="getOnPage1">
        采购时间
        <img src="../../assets/search.png" alt="" class="searchClass" @click="getOnPage">
    </div>
    <div class="swiper-container">
        <div class="swiper-wrapper">
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">采购时间参考</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">1. 普通的采购OA及费控，审批时间为10-15个工作日。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">2. 10万元以上的物资采购OA、费控，审批时间为15-25个工作日。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">3. 办公家具的采购，预计审批完成后35个工作日内完成。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">4. 课桌椅的采购，预计审批完成后25个工作日内完成。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">5. 窗帘的采购，预计审批完成后10个工作日内完成。</p>
                    <img src="../../assets/xiaNoPage.png" alt="" class="labourParticulars_bottomImg">
                </div>
            </div>
            <div class="swiper-slide">
                <div class="labourParticulars">
                    <h4 class="labourParticulars-title labourParticulars-title-active">采购时间参考</h4>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">6. 电脑、投影、监控、音响功放等采购，预计审批完成后10个工作日内完成。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">7.  办公用品、手机、微波炉、冰箱等京东慧采平台采购物资，预计审批完成后3个工作日内完成。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">8.  无纺布袋、定制T恤、定制普通书包（不用开模具定制）等定制物品，预计审批完成后10-15个工作日内完成。</p>
                    <p class="labourParticulars-title-content-active" id="textTitleContent">9.  开模具定制物品的采购，预计审批完成后35个工作日内完成。</p>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
export default {
    data() {
        return {
            fingerprintShow: false,
            flowShow: false,
            agreementShow: false
        };
    },
    methods: {
        getOnPage1(){
            var name = this.$route.params.name
            if(name == 'sd') {
                this.$router.push({name:"IssueManpower2"})
            }else {
                this.$router.push({name:"AssetHome"})
            }
        },
        fn() {
            
        },
        getOnPage(){
            this.$router.push({name: 'Search', params:{code:"1002"}})
        },
    },
    mounted() {
        this.fn();
        var mySwiper = new Swiper(".swiper-container", {
            direction: "vertical" // 垂直切换选项
            // loop: true // 循环模式选项
        });
    }
};
</script>

<style>
.swiper-container {
    width: 100%;
    height: 100%;
}

.box-labourParticulars {
    width: 100%;
    height: 100%;
    background: rgba(244, 244, 244, 1);
    overflow: hidden;
}

.nav {
    width: 100%;
    height: 50px;
    background: #11a093;
    text-align: center;
    line-height: 50px;
    color: #ffffff;
    position: relative;
    margin-bottom: 17px;
}

.upClass,
.searchClass {
    position: absolute;
    top: 0;
    bottom: 0;
    margin: auto;
}

.upClass {
    width: 12px;
    float: left;
    left: 10px;
}

.searchClass {
    width: 19px;
    float: right;
    right: 10px;
}

.labourParticulars {
    width: 90%;
    height: 83%;
    margin: 0 auto;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 3px 12px 0px rgba(136, 135, 135, 0.5);
    border-radius: 11px;
    padding-top: 5%;
    position: relative;
}

.labourParticulars .labourParticulars-title {
    text-align: center;
    font-weight: 600;
}

.labourParticulars .labourParticulars-hw {
    margin-bottom: 20px;
}

.labourParticulars p {
    color: #696969;
    font-size: 16px;
    margin: 25px 16px 0;
}

.labourParticulars span {
    display: block;
    line-height: 30px;
    margin-left: 16px;
    margin-right: 16px;
    color: #888787;
    font-size: 14px;
}

.labourParticulars .spanClass {
    text-indent: 30px;
}

.labourParticulars_bottomImg {
    width: 15%;
    display: block;
    left: 0;
    right: 0;
    margin: auto;
    position: absolute;
    bottom: 12px;
}

.QRcode {
    width: 30%;
    display: block;
    margin: 10px auto;
}
.labourParticulars-title-active {
    font-size: 16px
}
.labourParticulars-title-content-active {
    letter-spacing:2px;
    line-height: 30px;
}
#textTitleContent {
    color: #888787;
    font-size: 14px;
}

</style>



// WEBPACK FOOTER //
// src/components/assetflow/assetFlow4.vue